import React, { useRef, useEffect } from "react";
import videoFile from "../../components/car.mp4";
import audioFile from "../../components/lan.m4a";

function PurchaseLand() {
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  useEffect(() => {
      const playMedia = async () => {
        if (videoRef.current && audioRef.current) {
          try {
            await videoRef.current.play();
            await audioRef.current.play();
          } catch (error) {
            console.log("Autoplay blocked by browser, user interaction needed.");
          }
        }
      };
      playMedia();
    }, []);


  return (
    <div className="container">
      <div className="banner" onClick={handlePlay}>
        <video
          ref={videoRef}
          src={videoFile}
          autoPlay
          loop
          muted
          playsInline
          className="video"
        />
      </div>

      <audio ref={audioRef} src={audioFile} />

      <div className="container_body">
        <div className="course">
          <h1>How to Purchase Land for Under $1,000</h1>
          <p>
            Land Ownership Made Affordable! 🌄💸 Join Charles Noonan as he
            shares the secrets to purchasing land for under $1,000. Learn the
            strategies, resources, and insider tips to start building your real
            estate portfolio without breaking the bank. Let’s get you on the
            path to land ownership! 🚀 #LandInvestment #RealEstateDeals
          </p>
          <p>
            Charles Instagram:{" "}
            <a href="https://www.instagram.com/charlesjnoonan/?hl=en">
              https://www.instagram.com/charlesjnoonan/?hl=en
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default PurchaseLand;
